import { TLocale } from '@internal/utils/machine/i18n/Locale'
import { Machine } from '@internal/utils/machine/Machine'
import { SplideSlide } from '@splidejs/react-splide'
import React from 'react'
import { ProductCard } from '../ProductCard/ProductCard'
import styles from './machineryCard.module.scss'

interface Props {
  machine: Machine
  locale: TLocale
  url: string
}

export const MachineryCard: React.FC<Props> = React.memo(
  ({ machine, locale, url }) => (
    <SplideSlide className={styles.card}>
      <ProductCard
        title={machine.name}
        machine={machine}
        highlightData={{
          power: machine.enginePower,
          year: machine.yearOfProduction,
          hours: machine.engineHours,
        }}
        url={url}
        locale={locale}
      />
    </SplideSlide>
  )
)

MachineryCard.displayName = 'MachineryCard'
